import React from 'react';
import { Col, Pagination, Row } from 'antd';
import PropTypes from 'prop-types';
import { PreviewTela } from '@4beefopag/4bee-fopag-core/dist/molecules';
import { Loading } from '@4beefopag/4bee-fopag-core/dist/organisms';
import { APONTAMENTO } from '../../../services/apontamentoProducao';
import TabelaAdiantamento from '../../organisms/TabelaAdiantamento';
import TabelaMensal from '../../organisms/TabelaMensal';
import BotoesApontamento from '../../molecules/BotoesApontamento';
import TelaSemParametrizacao from './TelaSemParametrizacao';

/**
 * Componente Organism para container da tabela de apontamento
 */
function ApontamentoTableContainer({
  loadingCollaborators,
  parameterization,
  payrollSheet,
  competence,
  payroll,
  type,
  filteredCollaboratorsPagination,
  pagination,
  totals,
  orderBy,
  onChangeItemValues,
  onChangeOrder,
  onChangePagination,
  onChangePaginationSize,
  onSave,
  onProcess,
  onExportExcel,
  onImportExcel,
  onRequestContractSigning,
  onCancel,
  onDelete,
  onUpdate,
  onReopen,
  onBeforeUploadModal,
  display,
  authHeaders,
  onShowCreateParameterizationModal,
}) {
  if (loadingCollaborators) {
    return <Loading quantidade={3} />;
  }

  if (!parameterization && payrollSheet && competence) {
    return <TelaSemParametrizacao onCriarParamClick={() => onShowCreateParameterizationModal(true)} />;
  }

  if (!payrollSheet || !competence || !payroll) {
    return (
      <PreviewTela
        imagem="https://storage.googleapis.com/static-files-4fdd9378-835d-40e4-b124-36699ae5cc08/coop/apontamento_producao/undraw-online-payments-luau-2.png"
        title={'Aqui você pode realizar o fechamento\nda folha de pagamento dos seus cooperados…'}
        subTitle="E antecipar seus controles internos relacionados a esse tema."
      />
    );
  }

  if (!payroll.items?.length) {
    return <p>Nenhum cooperado encontrado.</p>;
  }

  return (
    <Row
      type="flex"
      gutter={[16, 16]}
    >
      {type === APONTAMENTO.tiposRequisicoes.adiantamento && (
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
        >
          <TabelaAdiantamento
            onChangeItemValues={onChangeItemValues}
            items={filteredCollaboratorsPagination.items}
            parametrizacao={parameterization}
            payrollId={payroll.id}
            isEditable={payroll.isEditable}
            totals={totals}
            createdByActorKind={payroll.createdByActorKind}
          />
        </Col>
      )}

      {type === APONTAMENTO.tiposRequisicoes.mensal && (
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
        >
          <TabelaMensal
            onChangeOrder={onChangeOrder}
            orderBy={orderBy}
            onChangeItemValues={onChangeItemValues}
            items={filteredCollaboratorsPagination.items}
            parametrizacao={parameterization}
            payrollId={payroll.id}
            isEditable={payroll.isEditable}
            totals={totals}
            createdByActorKind={payroll.createdByActorKind}
          />
        </Col>
      )}

      <Col>
        <Pagination
          current={pagination.currentPage}
          defaultPageSize={pagination.itemsPerPage}
          total={filteredCollaboratorsPagination.total}
          onChange={onChangePagination}
          onShowSizeChange={onChangePaginationSize}
          pageSizeOptions={[8, 15, 30, 50]}
          showSizeChanger
        />
      </Col>

      <BotoesApontamento
        onSalvar={onSave}
        onProcessar={onProcess}
        onExportarExcel={onExportExcel}
        onImportarExcel={onImportExcel}
        onRequestContractSigning={onRequestContractSigning}
        headers={authHeaders}
        urlAction={authHeaders?.urlAction}
        onCancelar={onCancel}
        onDeletar={onDelete}
        onAtualizar={onUpdate}
        onReabrir={onReopen}
        onBeforeUploadModal={onBeforeUploadModal}
        exibicao={display}
        requisicao={payroll}
      />
    </Row>
  );
}

ApontamentoTableContainer.propTypes = {
  loadingCollaborators: PropTypes.bool.isRequired,
  parameterization: PropTypes.shape({
    id: PropTypes.number,
    nome: PropTypes.string,
    email_alerta: PropTypes.string,
    exibe_param_apontamento: PropTypes.bool,
    atual_comp_ap_qtd_dias: PropTypes.number,
  }),
  payrollSheet: PropTypes.shape({
    id: PropTypes.number,
  }),
  competence: PropTypes.string,
  payroll: PropTypes.shape({
    id: PropTypes.number,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        cooperator: PropTypes.shape({
          id: PropTypes.number,
          nome: PropTypes.string,
        }),
      })
    ),
    isEditable: PropTypes.bool,
    createdByActorKind: PropTypes.string,
  }),
  type: PropTypes.string.isRequired,
  filteredCollaboratorsPagination: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        cooperator: PropTypes.shape({
          id: PropTypes.number,
          nome: PropTypes.string,
        }),
      })
    ),
    total: PropTypes.number,
  }).isRequired,
  pagination: PropTypes.shape({
    currentPage: PropTypes.number,
    itemsPerPage: PropTypes.number,
  }).isRequired,
  totals: PropTypes.shape({
    producao: PropTypes.string,
    variavel: PropTypes.string,
    reembolso: PropTypes.string,
    totalRendimentos: PropTypes.string,
    descontosDiversos: PropTypes.string,
    adiantamento: PropTypes.string,
    totalDebitos: PropTypes.string,
    liquido: PropTypes.string,
  }).isRequired,
  orderBy: PropTypes.shape({}),
  onChangeItemValues: PropTypes.func.isRequired,
  onChangeOrder: PropTypes.func.isRequired,
  onChangePagination: PropTypes.func.isRequired,
  onChangePaginationSize: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onProcess: PropTypes.func.isRequired,
  onExportExcel: PropTypes.func.isRequired,
  onImportExcel: PropTypes.func.isRequired,
  onRequestContractSigning: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onReopen: PropTypes.func.isRequired,
  onBeforeUploadModal: PropTypes.func.isRequired,
  display: PropTypes.shape({
    habilitarReabertura: PropTypes.bool,
    habilitarCancelar: PropTypes.bool,
    habilitarExcluir: PropTypes.bool,
    habilitarFiltros: PropTypes.bool,
    habilitarSolicitacaoAssinaturaContrato: PropTypes.bool,
  }).isRequired,
  authHeaders: PropTypes.shape({
    idRequisicao: PropTypes.number,
    tipo: PropTypes.string,
    idFolha: PropTypes.number,
    campos: PropTypes.arrayOf(PropTypes.string),
    validarCampos: PropTypes.bool,
    urlAction: PropTypes.string,
  }).isRequired,
  onShowCreateParameterizationModal: PropTypes.func.isRequired,
};

ApontamentoTableContainer.defaultProps = {
  parameterization: undefined,
  payrollSheet: undefined,
  competence: undefined,
  payroll: undefined,
  orderBy: undefined,
};

export default ApontamentoTableContainer;
